import axios from 'axios';
export function performHttpRequest(method, url, data, config = {}) {
    return axios({
        method: method,
        url: url,
        data: data,
        ...config,
    });
}